export const EXPORT_ENTITIES = {
  whitelistedEntities: ['stackingplan'],
};

export const isWhitelistedExportEntity = name => EXPORT_ENTITIES.whitelistedEntities.includes(name);
